function initAddonInfoIcons() {
  if (window._addonInfoIconLoaded) return;
  window._addonInfoIconLoaded = true;

  function attachIcon(icon) {
    if (icon._addonInfoAttached) return;
    icon._addonInfoAttached = true;

    const positionTooltip = () => {
      const rect = icon.getBoundingClientRect();
      icon.classList.toggle('addon-info-icon--below', rect.top < 140);
      icon.classList.toggle('addon-info-icon--tip-left', rect.right > window.innerWidth - 140);
    };

    icon.addEventListener('mouseenter', positionTooltip);

    icon.addEventListener('click', e => {
      e.stopPropagation();
      positionTooltip();
      const isOpen = icon.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.addon-info-icon[aria-expanded="true"]').forEach(i => {
        i.setAttribute('aria-expanded', 'false');
      });
      icon.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }

  document.querySelectorAll('.addon-info-icon').forEach(attachIcon);

  // Close on outside click or tap
  const closeAll = () => {
    document.querySelectorAll('.addon-info-icon[aria-expanded="true"]').forEach(i => {
      i.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', closeAll);
  document.addEventListener('touchstart', closeAll, { passive: true });

  // Re-attach if new icons are injected later (e.g. swap containers becoming visible)
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.addon-info-icon').forEach(attachIcon);
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAddonInfoIcons);
} else {
  initAddonInfoIcons();
}
